var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.281,
    height: 138.375,
    viewBox: "0 0 96.281 138.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3519",
    "data-name": "Path 3519",
    d: "M102.844,0H9.281V-18.562L53.438-65.625A108.933,108.933,0,0,0,66.891-82.969q4.359-7.406,4.359-14.062,0-9.094-4.594-14.3t-13.125-5.2q-9.187,0-14.484,6.328t-5.3,16.641H6.563a44.75,44.75,0,0,1,5.953-22.781,41.958,41.958,0,0,1,16.828-16.172A51.148,51.148,0,0,1,54-138.375q21.094,0,32.766,10.125T98.438-99.656a45.9,45.9,0,0,1-5.25,20.625q-5.25,10.5-18,24.469L44.156-21.844h58.688Z",
    transform: "translate(-6.563 138.375)",
    fill: "#f37320",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.0b5a95bca75fb22841ceab5096ff0adb.svg";
export { ForwardRef as ReactComponent };